import React, { useState } from 'react';
import { Box, Tooltip, IconButton, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import fieldMapping from './images/Field-mapping.png';
// import NoMapping from './images/No-transformation.svg';
import DecisionMappng from './images/decision_icon.svg';
import Jira from './images/JIRA.svg';
import Integration from './images/Integartion.png';
import BacktrackIcon from './images/backtrack.svg';
import { capitalize } from '../utils/formatters/stringFormatter';

const ITEMS = [
  { name: 'Field-Mapping', type: 'mapping', icon: fieldMapping },
  { name: 'Jira', type: 'Jira', icon: Jira },
  { name: 'decision', type: 'decision', icon: DecisionMappng },
  // { name: 'No Transformation', type: 'noTransformation', icon: NoMapping },
  { name: 'Bidirectional', type: 'backtrack', icon: BacktrackIcon },
];

const IntegretionPanelPill = () => {
  const [hovered, setHovered] = useState(false);
  const onDragStart = (name) => (e) => {
    e.dataTransfer.setData('application/reactflow', name);
    // Set nodeType based on the item type, especially for Bidirectinal
    const nodeType = name === 'Bidirectional' ? 'Backtrack' : 'Integretion';
    e.dataTransfer.setData('nodeType', nodeType);
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 0.2,
        mb: 0.2,
        px: 2,
      }}
    >
      <motion.div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        whileHover={{ y: -1, boxShadow: '0px 6px 22px rgba(113,185,255,0.25)' }}
        transition={{ type: 'spring', stiffness: 250, damping: 22 }}
        style={{
          position: 'relative',
          height: 50,
          minWidth: 380,
          padding: '0 24px',
          borderRadius: 9999,
          background: '#fff',
          boxShadow: '0px 0px 6px 0px #9c71ff33',
          border: '1px solid #5965A6',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <AnimatePresence mode="wait">
          {!hovered ? (
            <motion.div
              key="title"
              initial={{ opacity: 0, y: 4 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.18 }}
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <img
                src={Integration}
                alt="Integration"
                width={20}
                height={20}
                style={{
                  filter:
                    'invert(19%) sepia(72%) saturate(1604%) hue-rotate(213deg) brightness(93%) contrast(92%)',
                }}
              />
              <Typography sx={{ fontWeight: 600, color: '#5965A6' }}>
                {/* Integration */}
                Logic
              </Typography>
            </motion.div>
          ) : (
            <motion.div
              key="icons"
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.18 }}
              style={{ display: 'flex', gap: 16 }}
            >
              {ITEMS.map((it, i) => (
                <motion.div
                  key={it.name}
                  initial={{ y: 6, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.03 * i, duration: 0.18 }}
                >
                  <Tooltip title={capitalize(it.name)}>
                    <IconButton
                      draggable
                      onDragStart={onDragStart(it.name)}
                      sx={{
                        width: 42,
                        height: 42,
                        borderRadius: '4px',
                        background: '#D6E1FF',
                        boxShadow: '0px 0px 6px 0px #71B9FF33',
                        '&:hover': { bgcolor: '#E6EBFB' },
                        color: '#5965A6',
                      }}
                    >
                      <img
                        src={it.icon}
                        alt={it.name}
                        width={20}
                        height={20}
                        style={{
                          filter:
                            'invert(19%) sepia(72%) saturate(1604%) hue-rotate(213deg) brightness(93%) contrast(92%)',
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </motion.div>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </Box>
  );
};

export default IntegretionPanelPill;
